import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  Renderer2,
} from '@angular/core';
import { fadeAnimation } from './animations';
import { Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { WhatsappService } from './pages/page-whatsapp/whatsapp.service';
import { AllService } from './services/all.service';
import { environment } from 'src/environments/environment';
import { ThemeService } from './services/theme.service';
import packageInfo from '../../package.json';
import { SettingsService } from './services/settings.service';
import { InterfaceService } from './services/interface.service';
import {CallService} from './services/call.service';
import {document} from 'ngx-bootstrap/utils';
import {DcService} from './services/dc.service';
import { TelegramService } from "./pages/page-telegram/telegram.service";
import { takeUntil } from "rxjs";
declare let pageLoaderStop: any;
declare const loaderTimer: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    fadeAnimation
    // animation triggers go here
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class AppComponent implements OnInit, AfterViewInit {
  title = '';
  public version: string = packageInfo.version;
  environment = environment;
  constructor(
    private renderer: Renderer2,
    public settingsService: SettingsService,
    private cd: ChangeDetectorRef,
    public whatsappService: WhatsappService,
    public router: Router,
    public allService: AllService,
    public themeService: ThemeService,
    public interfaceService: InterfaceService,
    public callService: CallService,
    private dcService: DcService,
  ) {

  }

  ngOnInit() {
    const localValue = this.allService.getVarLocal('chats-filter', false);
    if (typeof localValue !== 'boolean') {
      this.interfaceService.filterType = localValue;
    }else if (this.interfaceService.isTelesellerDomain){
      this.interfaceService.filterType = 'private';
    }

    this.interfaceService.openChat$.subscribe(() => {
      this.interfaceService.setFullSize(this.renderer, false);
    });
    this.allService.setService$.subscribe((type) => {
      this.interfaceService.setFullSize(this.renderer, false);
    });

    this.allService.setService$.subscribe((type) => {
      this.interfaceService.setThemeColor(type);
    });
    this.dcService.detectChanges$.pipe(filter(v => v === 'app-root')).subscribe((component) => {
      this.cd.detectChanges();
    });
    this.interfaceService.setTheme$.subscribe((type) => {
      try {
        this.renderer.setAttribute(document.body, 'active-service', type);
      }catch (e) {
        console.warn(e);
      }
    });
  }
  ngAfterViewInit() {
    pageLoaderStop = true;
    setTimeout(() => {
      clearInterval(loaderTimer);
      window.document.getElementById('pageLoad').className += ' active';
      document.getElementById('pageLoad').remove();
    }, 500);
    this.themeService.changeTheme(true);
    // this.metrikaInit();
  }
}
